import { Grid } from "@mui/material";
import React from "react";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { useForm } from "react-hook-form";
import WSDateField from "../../Components/DateField/WSDateField";

export const Stock: React.FC<any> = React.memo((props) => {
  const { register, control } = useForm();
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <WSTextField
            label={"Opening Quantity"}
            {...register("openingQuantity")}
            id="openingQuantity"
            name="openingQuantity"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSTextField
            label={"At Price"}
            {...register("atPrice")}
            id="atPrice"
            name="atPrice"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSDateField
            id="asOfDate"
            name="asOfDate"
            label={" As Of Date "}
            dateFormat="DD-MM-YYYY"
            denyFuturOrPast="custom"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSTextField
            label={"Mini Stock To Maintain"}
            {...register("ministock")}
            id="ministock"
            name="ministock"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSTextField
            label={"Location"}
            {...register("location")}
            id="location"
            name="location"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
      </Grid>
    </>
  );
});
